import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOrecursoEstrutura = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>

                    <HeaderVerde texto="SETORES DA ASSISTÊNCIA" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Setores de Assistências que Possuem Terapeutas" nome="tosetoresterapeutas" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                        {RenderCondicional()}
                    </div>

                    <HeaderVerde texto="RECURSOS E ESTRUTURA FÍSICA DOS LOCAIS DE ASSISTÊNCIA" />
                    <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                </Caixa>
            )
            function RenderCondicional() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["tosetoresterapeutas"]
                if (array[modulo][n]["tosetoresterapeutas"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Setor" nome="tosetor" modulo={modulo} index={n} subModulo="tosetor" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="37vw" widthMobile="80vw" marginR="3vw" />

                                <Input label="Assistência(h/dia)" nome="toassistenciah" modulo={modulo} index={n} subModulo="toassistenciah" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
            return partes
        }
    }

    export default TOrecursoEstrutura